// cssをインポート
import "../sass/base.scss";  // wsのベース
import "../sass/style.scss"; // 上書き等

require('./common');
